module.exports = __webpack_public_path__ + "img/caret-up-fill.561bc76d.svg";